import channelConfig from '../config/channel.config';

export default function (path: string): string | undefined {
  const channel = channelConfig.find((channel) => channel.path === path);

  return channel ? channel.url : undefined;
}
